/**
 * Copyright (c) 2019-Present Syncari - All rights reserved.
 */
import cx from 'classnames';
import * as React from 'react';

import type { CheckboxFieldProps } from '../../types';
import Checkbox from './Checkbox';
import './CheckboxField.less';

let _checkboxFieldIdCounter = 0;

const CheckboxField = ({
  name,
  label,
  description,
  checked,
  defaultChecked,
  disabled,
  onChange,
  id,
  className,
}: CheckboxFieldProps) => {
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const autoId = React.useMemo(() => `ds-checkbox-field-${++_checkboxFieldIdCounter}`, []);
  const resolvedId = id ?? autoId;

  return (
    <label htmlFor={resolvedId} className={cx('checkbox-field', { 'checkbox-field--disabled': disabled }, className)}>
      <Checkbox
        id={resolvedId}
        name={name}
        checked={checked}
        defaultChecked={defaultChecked}
        disabled={disabled}
        onChange={onChange}
      />
      <span className="checkbox-field__text">
        <span className="checkbox-field__label">{label}</span>
        {description && (
          <>
            <span className="checkbox-field__separator" aria-hidden="true">
              {' – '}
            </span>
            <span className="checkbox-field__description">{description}</span>
          </>
        )}
      </span>
    </label>
  );
};

CheckboxField.displayName = 'CheckboxField';

export default CheckboxField;
